import { useEffect } from "react";
import { useLocation } from "react-router";
import StepManager from "../../components/feature/StepManager";
import { stepperData } from "../../constant/appConstant";
import DefaultLayout from "../../layout";
import {
  setStepData,
  setStepperConfig
} from "../../redux/slices/customerJourney";
import { useAppDispatch, useAppSelector } from "../../redux/store";

const CustomerJourney = () => {
  const dispatch = useAppDispatch();

  const toggleStepperConfig = (stepNumber: number) => {
    let temp: string = JSON.stringify(stepperData);
    let data = JSON.parse(temp);
    data = data.map((item: any, index: number) => {
      if (index < stepNumber) {
        item.completed = true;
        return item;
      } else if (stepNumber === index) {
        item.selected = true;
        item.completed = false;
        dispatch(setStepData({ data: item }));
        sessionStorage.setItem("currentStep", JSON.stringify(item));
        return item;
      } else {
        item.selected = false;
        item.completed = false;
        return item;
      }
    });
    dispatch(setStepperConfig({ data: data }));
  };

  const stepDataManager = () => {
    if (sessionStorage.getItem("currentStep")) {
      let data: any = sessionStorage.getItem("currentStep");
      data = JSON.parse(data);
      toggleStepperConfig(data?.stepNumber - 1);
    } else {
      toggleStepperConfig(0);
    }
  };

  useEffect(() => {
    dispatch(setStepperConfig({ data: stepperData }));
    stepDataManager();
  }, []);

  return (
    <>
      <DefaultLayout>
        <StepManager stepDataManager={stepDataManager} />
      </DefaultLayout>
    </>
  );
};

export default CustomerJourney;
